import { TenantEntity } from '../TenantEntity'
import { queryOperationRequirementDescription } from '@/api/operation'

export class OperationRequirementDescription extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get descriptionId() {
    return this._data.descriptionId
  }
  set descriptionId(descriptionId) {
    this._data.descriptionId = descriptionId || 0
  }
  get lob() {
    return this._data.lob
  }
  set lob(lob) {
    this._data.lob = lob
  }
  get operationRequirementType() {
    return this._data.operationRequirementType
  }
  set operationRequirementType(operationRequirementType) {
    this._data.operationRequirementType = operationRequirementType || 0
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    this._data.code = code
  }
  get contentDescription() {
    return this._data.contentDescription
  }
  set contentDescription(contentDescription) {
    this._data.contentDescription = contentDescription
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  static async getListByLob(lob) {
    return await queryOperationRequirementDescription({ lob: lob }).then(res => res.data || [])
  }
}
